module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMA/wD/AP83WBt9AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAOklEQVQokWP8//8/AymAiSTV5GhggVDp6ekElc6cOROhAc7HBeAmsmAK4QeMpIbSqB/wqKajH0hOfADLqyHCK529XwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// E:/Atlassian/bamboo-home/1/7766019/ESDE-EN172-JOB1/ng5/node_modules/jqwidgets-framework/jqwidgets/styles/images/icon-menu-small.png
// module id = ../../../../jqwidgets-framework/jqwidgets/styles/images/icon-menu-small.png
// module chunks = styles